<template>
  <div>
      <h3><b-badge variant="warning">Loading publications...</b-badge></h3>
  </div>
</template>

<script>
export default {
  name: 'LoadingPublications',
  computed: {
    
  },
  methods: {

  }
}
</script>